// Selects the audit data source. The static mock is the default so the shell
// preview stays backendless; set VITE_AUDIT_LIVE=1 (or "true") to point the
// reviewer workbench at the live evalreview.v1 service (HUB-512) — real coding
// data from the PDF path. Run e.g. `VITE_AUDIT_LIVE=1 npm run dev`.
import type { AuditDataSource } from '../AuditDataSource';
import { mockAuditSource } from './mockAuditSource';
import { liveAuditSource } from './liveAuditSource';

const flag = import.meta.env.VITE_AUDIT_LIVE;
const useLive = flag === '1' || flag === 'true';

export const auditSource: AuditDataSource = useLive ? liveAuditSource : mockAuditSource;
export const auditSourceMode: 'live' | 'mock' = useLive ? 'live' : 'mock';
